import { Typography } from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import {
  FormattedDate,
  FormattedRelativeTime,
  parseDate,
  toPrimitiveDateInput,
} from '@superdispatch/dates';
import { ColorDynamic, Inline } from '@superdispatch/ui';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import styled from 'styled-components';

const EditedText = styled(Typography)`
  color: ${ColorDynamic.Yellow500};
`;

interface PostingEditedLabelProps {
  loadEditedAt: string;
  variant: 'list' | 'detail';
}

export function PostingEditedLabel({
  loadEditedAt,
  variant,
}: PostingEditedLabelProps) {
  const primitiveInput = toPrimitiveDateInput(loadEditedAt);
  const date = useMemo(
    () => parseDate(primitiveInput, { format: 'JodaISO' }),
    [primitiveInput],
  );
  const today = useMemo(() => DateTime.local(), []);

  if (!date.isValid) {
    return null;
  }

  if (variant === 'detail') {
    return (
      <Inline space="xxsmall" verticalAlign="center" noWrap={true}>
        <Edit htmlColor={ColorDynamic.Yellow500} fontSize="small" />
        <EditedText variant="body2" noWrap={true}>
          Edited by Shipper on <FormattedDate date={date} variant="ShortDate" />
        </EditedText>
      </Inline>
    );
  }

  return (
    <Inline space="xxsmall" verticalAlign="center" noWrap={true}>
      <Edit htmlColor={ColorDynamic.Yellow500} style={{ fontSize: 16 }} />
      <EditedText variant="body2" noWrap={true}>
        Edited{' '}
        {date.hasSame(today, 'day') ? (
          <FormattedRelativeTime format="JodaISO" date={loadEditedAt} />
        ) : (
          <FormattedDate date={date} variant="ShortDate" />
        )}
      </EditedText>
    </Inline>
  );
}
